module.exports = __webpack_public_path__ + "img/swper1.e6881d53.png";